import { render, staticRenderFns } from "./BotpressChat.vue?vue&type=template&id=e59449da"
import script from "./BotpressChat.vue?vue&type=script&lang=js"
export * from "./BotpressChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports